import axios from 'axios';
import { API_URL } from '../config';

export type UserRole = 'admin' | 'agent' | 'livreur';

export interface ManagedUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  deliveryZones?: Array<string | { _id: string; name: string; price: number }>;
  createdAt?: string;
}

export interface UserFormData {
  firstName: string;
  lastName: string;
  email: string;
  password?: string;
  role: UserRole;
  deliveryZones?: string[];
}

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});

export const userService = {
  getAll: async (): Promise<ManagedUser[]> => {
    const response = await axios.get(`${API_URL}/users`, authHeaders());
    return response.data.data;
  },

  create: async (data: UserFormData): Promise<ManagedUser> => {
    const response = await axios.post(`${API_URL}/users`, data, authHeaders());
    return response.data.data;
  },

  update: async (id: string, data: UserFormData): Promise<ManagedUser> => {
    const response = await axios.put(`${API_URL}/users/${id}`, data, authHeaders());
    return response.data.data;
  },

  delete: async (id: string) => {
    const response = await axios.delete(`${API_URL}/users/${id}`, authHeaders());
    return response.data;
  },

  updateMyZones: async (deliveryZones: string[]) => {
    const response = await axios.put(
      `${API_URL}/users/profile`,
      { deliveryZones },
      authHeaders()
    );
    return response.data.data;
  }
};

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Admin',
  agent: 'Agent',
  livreur: 'Livreur',
};
